<template>
  <div class="main">
    <report-top> </report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun"
          >立即分析</Button
        ></template
      ></selectTool
    ><div id="cshou"></div>
    
      
      <Table
        border
        :columns="columns"
        :data="tableData"
        no-data-text="<div class='table-no-data'></div>"
        :height="400"
        show-summary
      >
        <template slot-scope="{ row, index }" slot="action">
          <Button size="small" @click="openUpdateStatus(row, index)"
            >应付</Button
          >
          <Button size="small" @click="openUpdateStatus1(row, 1)">应收</Button>
        </template>
      </Table>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      item: {
        //tuli: ["应付总金额", "打哈欠报警"],
        title: "应付总金额统计",
        xData: ["10-01", "10-02", "10-03", "10-04", "10-05", "10-06", "10-07"],
        yData: [
          {
            name: "应付总金额",
            type: "line",
            stack: "Total",
            data: [120, 132, 101, 134, 90, 230, 210],
          },
          {
            name: "打哈欠报警",
            type: "line",
            stack: "Total",
            data: [220, 182, 191, 234, 290, 330, 310],
          },
        ],
      },
      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "4",
        },
      ],
      columns: [
        {
          title: "日期",
          key: "reportDate",
        },
        {
          title: "应付总金额",
          key: "totalAmountPayable",
        },
        {
          title: "应收总金额",
          key: "totalAmountReceivable",
        },
        {
          title: "已收金额",
          key: "amountReceivable",
        },
        {
          title: "待收金额",
          key: "amountReceivableUn",
        },
        {
          title: "已付金额",
          key: "amountPayable",
        },
        {
          title: "待付金额",
          key: "amountPayableUn",
        },
      ],
      tableData: [],
    };
  },
  methods: {
    getData() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-fms/accountsReceivable/reportAmount",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        var data = res.data.data;
        this.tableData = data;
        console.log(data);
        var xData = [],
          list1 = [],
          list2 = [],
          list3 = [],
          list4 = [],
          list5 = [],
          list6 = [];
        for (let i = 0; i < data.length; i++) {
          xData.push(data[i].reportDate);
          list1.push(data[i].totalAmountPayable);
          list2.push(data[i].totalAmountReceivable);
          list3.push(data[i].amountReceivable);
          list4.push(data[i].amountReceivableUn);
          list5.push(data[i].amountPayable);
          list6.push(data[i].amountPayableUn);
        }
        this.item.xData = xData;
        this.item.yData = [
          {
            name: "应付总金额",
            type: "line",
           // stack: "Total",
            data: list1,
          },
          {
            name: "应收总金额",
            type: "bar",
            //stack: "Total",
            data: list2,
          },
          {
            name: "已收金额",
            type: "bar",
            //stack: "Total",
            data: list3,
          },
          {
            name: "待收金额",
            type: "bar",
            //stack: "Total",
            data: list4,
          },
          {
            name: "已付金额",
            type: "bar",
            //stack: "Total",
            data: list5,
          },
          {
            name: "待付金额",
            type: "bar",
            //stack: "Total",
            data: list6,
          },
        ];

        this.draw("cshou", this.item);
      });
    },
    payOut() {
      return;
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-fms/accountsPayable/reportAmount",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        var xData = [],
          yData = [];
        for (let i = 0; i < data.length; i++) {
          xData.push(data[i].reportDate);
          yData.push(data[i].totalAmountPayable);
        }
        this.item.bb.xData = xData;
        this.item.bb.yData = [];
        var obj = {
          name: "应付账款",
          type: "line",
          stack: "Total",
          data: yData,
        };
        this.item.bb.yData.push(obj);
        this.draw("cfu", this.item.bb);
      });
    },
    draw(id, data) {
      this.chart = this.echarts.init(document.getElementById(id));
      this.option = {
       /*  title: {
          text: data.title,
          top: 20,
          left: 20,
          fontSize: 12,
        }, */
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: 20, //图例组件离右边的距离
          // orient: "vertical", //布局  纵向布局
          orient: "horizontal", //布局  纵向布局
          width: 550, //图行例组件的宽度,默认自适应
          x: "right", //图例显示在右边
          itemWidth: 10, //图例标记的图形宽度
          itemHeight: 10, //图例标记的图形高度
          textStyle: {
            //图例文字的样式
            color: "#000",
            fontSize: 12,
          },
          data: data.tuli,
        },
        grid: {
          x: 80,
          y: 30,
          x2: 50,
          y2: 50, //距离下边的距离
        },
        /* toolbox: {
          feature: {
            saveAsImage: {},
          },
        }, */
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: data.xData,
        },
        yAxis: {
          type: "value",
        },
        series: data.yData,
      };

      this.chart.setOption(this.option);

      this.chart.resize();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      
      this.getData();
      //this.payOut();
    },
  },
  mounted() {
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>
<style>

#cshou {
  width: 100%;
  height:300px;
  background: #fff;
}

</style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwu/caiwufenxi.vue